angular
    .module("digitalLeasing.module")
    .component("questionarioPrestoLeasing", {
        templateUrl: "ng/components/digitalLeasing/nuovoPrestoLeasing/questionarioPrestoLeasing/questionarioPrestoLeasing.view.html",
        bindings: {
            model: "=",
            questionarioPrestoLeasing: "=",
            exportValidityQuestionario: "&",
            prestoLeasingIsOk: "&"
        },
        controllerAs: "questionarioPrestoLeasingCtrl",
        controller: function QuestionarioPrestoLeasing(
            $scope,
            $timeout
        ) {
            var self = this;

            self.$onInit = function () {
                self.supportModel = {
                    sezioniNascoste: false,
                    optionDefault: undefined
                }
                self.showHideAlertText=false;

                if (self.model.preventivo.questionarioNuovoPrestoleasing.length === 0) {
                    self.questionarioPrestoLeasing.forEach(function (questionario) {
                        questionario.domande.forEach(function (domanda) {
                            domanda.rispostaAffermativa = undefined
                        })
                    })
                    self.model.preventivo.questionarioNuovoPrestoleasing = self.questionarioPrestoLeasing;
                } else {
                    self.questionarioPrestoLeasing.forEach(function (questionario) {
                        questionario.domande.forEach(function (domanda) {
                            if (domanda.dropDown) {
                                domanda.options.forEach(function (option) {
                                    if (option.selected) {
                                        self.supportModel.optionDefault = option;
                                    }
                                })
                            }
                        })
                        self.checkDropDown= self.questionarioPrestoLeasing.find(function(element){
                                    return element.id.substring(0,6) =='TITESC'
                                }).domande.some(function(x){
                                    return x.domanda.dropDown == true
                                })

                        if (self.supportModel.optionDefault && self.supportModel.optionDefault.vincoloNpl) {
                                self.supportModel.sezioniNascoste = true;
                                self.checkPrestoLeasingIsOk(false);
                            
                        }
                    })
                }
                checkShowHideAlert();
                self.checkQuestionarioPrincipale();
            }

            self.handleChange = function (property, value) {
                if (property === 'tipoBene') {
                    value.rispostaAffermativa = false;

                    if (value.dropDown) {
                        value.options.forEach(function (option) {
                            if (self.supportModel.optionDefault.name === option.name) {
                                option.selected = true;
                            } else {
                                option.selected = false;
                            }
                        })
                    }

                    if(self.supportModel.optionDefault.name ==='BENNEW_LBL'){
                        self.questionarioPrestoLeasing.forEach(function(element){
                            element.domande.forEach(function(el){
                                if(el.usato){
                                    el.rispostaAffermativa = false;
                                }
                            })
                        })
                    }else {
                        self.questionarioPrestoLeasing.forEach(function(element){
                            element.domande.forEach(function(el){
                                if(el.usato){
                                    el.rispostaAffermativa = undefined;
                                }
                            })
                        })

                    }
                }
                console.log($scope.questionarioPrestoLeasing);
                checkShowHideAlert();
                self.checkQuestionarioPrincipale();
            }

            self.validityQuestionario = function (validity) {
                /* self.exportValidityQuestionario({
                    validity: validity
                }) */
            }

            self.checkPrestoLeasingIsOk = function (prestoLeasingIsOk) {
                var enalbeMex = self.questionarioPrestoLeasing[0].domande
                                .some(function(element){
                                    return element.rispostaAffermativa == true
                                })
                enalbeMex = enalbeMex || (self.supportModel.optionDefault && self.supportModel.optionDefault.vincoloNpl)
                self.prestoLeasingIsOk({
                    prestoLeasingIsOk: enalbeMex
                })

                if (!prestoLeasingIsOk) {
                    self.questionarioPrestoLeasing.forEach(function (questionario) {
                        self.questionarioSubstring = questionario.id.substring(0, 6);
                        if (self.questionarioSubstring === 'TITESC') { 
                            return;
                        } else {
                            questionario.domande.forEach(function (domanda) {
                                domanda.rispostaAffermativa = undefined
                            })
                        }
                    })
                }
            }

            self.checkAllQuestionari = function () {
                self.result = undefined;

                self.questionarioPrestoLeasing.forEach(function (questionario) {
                    self.result = questionario.domande.some(function (domanda) {
                        return domanda.rispostaAffermativa === undefined
                    })
                })

                if (self.result && !self.supportModel.sezioniNascoste) {
                    return false;
                }
                return true;
            }

            self.checkQuestionarioPrincipale = function () {
                self.questionarioPrestoLeasing.forEach(function (questionario) {
                    self.questionarioSubstring = questionario.id.substring(0, 6);
                    if (self.questionarioSubstring === 'TITESC') { 
                        var result = questionario.domande.some(function (domanda) {
                            return domanda.rispostaAffermativa || domanda.rispostaAffermativa === undefined
                        })

                        if (result) {
                            self.supportModel.sezioniNascoste = true;

                            var questionarioIsOk = questionario.domande.some(function (domanda) {
                                return domanda.rispostaAffermativa === undefined
                            })

                            if (questionarioIsOk) {
                                self.validityQuestionario(false);
                            } else {
                                self.validityQuestionario(true);
                            }

                            self.checkPrestoLeasingIsOk(false);
                        } else {
                            self.supportModel.sezioniNascoste = false;

                            var validity = self.checkAllQuestionari();

                            if (validity) {
                                self.validityQuestionario(true);
                            } else {
                                self.validityQuestionario(false);
                            }
                            self.checkPrestoLeasingIsOk(true);
                        }

                        if (self.supportModel.optionDefault && self.supportModel.optionDefault.vincoloNpl) {

                            self.supportModel.sezioniNascoste = true;
                            self.checkPrestoLeasingIsOk(false);
                            
                        }
                    } else {
                        var validity = self.checkAllQuestionari();

                        if (validity) {
                            self.validityQuestionario(true);
                        } else {
                            self.validityQuestionario(false);
                        }
                    }
                })
                $timeout(function(){
                    self.exportValidityQuestionario({
                        validity: $scope.questionarioPrestoLeasing.$valid
                    })

                },500)
                
            }

            var checkShowHideAlert = function(){
                var defQuestions={}
                self.questionarioPrestoLeasing.forEach(function(element){
                    element.domande.forEach(function(domanda){
                        if(domanda.cdDomanda=="DEF"){
                            defQuestions= domanda;
                         }
                    })
                })

                var elementSelected = defQuestions && defQuestions.options && defQuestions.options.find(function(element){
                    return element.selected == true 
                })

                var valueOfSelected ="" 
                if(elementSelected && elementSelected.value){
                    //cambio valori di valueOfSelected per uniformità con lo stato del bene contratto

                    switch (elementSelected.value) {
                        case 'BENOLD':
                            valueOfSelected= "LBL_GOOD_STATE_NOT_NEW";
                            break;
                        
                        case 'BENNEW':
                            valueOfSelected= "LBL_GOOD_STATE_NEW";
                            break;

                        case 'BENKM0':
                            valueOfSelected= "LBL_GOOD_KM_0";
                            break;
                    
                        default:
                            break;
                    }

                }



                if(self.model.preventivo.prodotto.beneContratto.length && valueOfSelected){

                    self.showHideAlertText= self.model.preventivo.prodotto.beneContratto.some(function(element){
                        return element.stato != valueOfSelected
                    })

                    self.beneStatoDifferente= self.model.preventivo.prodotto.beneContratto.find(function(element){
                        return element.stato != valueOfSelected
                    })
                }
            }
        }
    })